import React from 'react'
import "./Navbar.scss"
import { useDispatch, useSelector } from 'react-redux';
import phone from "../../assets/phone.svg"
import mail from "../../assets/mail.svg"
import insta from "../../assets/insta.svg"
import tt from "../../assets/tt.svg"
import fb from "../../assets/fb.svg"
import logo from "../../assets/logo.jpg"
import order from "../../assets/order-white.svg"
import user from "../../assets/user-white.svg"
import logout from "../../assets/logout.svg"
import { useHistory } from 'react-router';
import more from "../../assets/more.svg"
import { setSelectedOrderType } from '../../../../../../../redux/resturantWidgetSlice';
import { setShowLogin } from '../../../../../../../redux/companyDataSlice';





const Navbar = ({ setIsMenuOpen }) => {
    const company = useSelector((state) => state.companyData.company);
    const history = useHistory()
    const dispatch = useDispatch()
    const navs = [
        {
            "title": "Home",
            "href": "/"
        }, {
            "title": "Menu",
            "href": "/page/menu"
        }, {
            "title": "Contact",
            "href": "/page/contact"
        },
    ]
    const handleLogout = () => {
        sessionStorage.clear()
        localStorage.clear()
        window.location.href = '/menu'
    };
    return (
        <div className='Regal-navbar'
            id="online-navbar">
            <div className='Regal-navbar-top'>
                <div className='Regal-navbar-top-left'>
                    <div className='Regal-navbar-top-left-item'>
                        <img alt='' src={phone} />
                        {company?.Phone}
                    </div>
                    <div className='Regal-navbar-top-left-item'>
                        <img alt='' src={mail} />
                        {company?.Email}
                    </div>
                </div>
                <div className='Regal-navbar-top-right'>
                    Follow Us  :
                    {company?.SocialMedias
                        ?.instagram && company?.SocialMedias
                            ?.instagram !== "" && <img alt='' src={insta}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.instagram, '_blank')
                                }} />}
                    {company?.SocialMedias
                        ?.tiktok && company?.SocialMedias
                            ?.tiktok !== "" && <img alt='' src={tt}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.tiktok, '_blank')
                                }} />}
                    {company?.SocialMedias
                        ?.facebook && company?.SocialMedias
                            ?.facebook !== "" && <img alt='' src={fb}
                                onClick={() => {
                                    window.open(company?.SocialMedias
                                        ?.facebook, '_blank')
                                }} />}
                </div>
            </div>
            <div className='Regal-navbar-bottom'>
                <img alt='' className='Regal-logo'
                    src={logo} />
                <div className='Regal-navbar-bottom-nav'>
                    {navs.map((nav, key) => {
                        return (
                            <div key={key}
                                onClick={() => {
                                    history.push(nav?.href)
                                }}
                                className={window.location.pathname === nav?.href ? 'Regal-navbar-bottom-nav-item-selected' : 'Regal-navbar-bottom-nav-item'}>
                                {nav?.title}
                            </div>
                        )
                    })}
                </div>
                {window.location.pathname === "/menu" ? localStorage.getItem('isLogged') === 'true' ?
                    <div className='Regal-order-btn'
                        onClick={handleLogout}>
                        <img alt=''
                            src={logout} />
                        Log out
                    </div> : <div className='Regal-order-btn'
                        onClick={() => {
                            dispatch(setShowLogin(true))
                        }}>
                        <img alt=''
                            src={user} />
                        Log in
                    </div> : <div className='Regal-order-btn'
                        onClick={() => {
                            dispatch(setSelectedOrderType("collection"))
                            history.push("/menu")
                        }}>
                    <img alt=''
                        src={order} />
                    Click & Collect
                </div>}
                <img alt='' className='Regal-navbar-bottom-more'
                    src={more}
                    onClick={() => {
                        setIsMenuOpen(true)
                    }} />
            </div>
        </div>
    )
}
export default Navbar